import { render } from "./company-parents.vue?vue&type=template&id=48bc4005&scoped=true"
import script from "./company-parents.vue?vue&type=script&lang=js"
export * from "./company-parents.vue?vue&type=script&lang=js"

import "./company-parents.vue?vue&type=style&index=0&id=48bc4005&lang=less&scoped=true"

import exportComponent from "/Users/jixubin/yunsi/bzcircle-merchant-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bc4005"]])

export default __exports__